// @flow

import React from "react"
import styled from "styled-components"
import iconDownArrow from "../Icons/iconDownArrow.svg"
import SVGLoader from "../../UI/SVGLoader"

const CTAContainer = styled.h3`
  font-family: "din-condensed";
  font-weight: 400;
  color: ${({ appearance }) => {
    switch (appearance) {
      case "light":
        return "#fff"
      case "dark":
        return "#002943"
      case "blue":
        return "#005890"
      default:
        return "#fff"
    }
  }};
  font-size: 36px;
  margin: 22px auto auto ${({ centered }) => (centered ? "auto" : 0)};
  display: flex;
  align-items: center;

  & > * {
    margin-right: 0.25em;
  }
`

type Direction = "up" | "down" | "left" | "right"
type Appearance = "light" | "dark" | "blue"

const styleForDirection = (direction: Direction): { [string]: string } => {
  let rotation: number
  switch (direction) {
    case "up":
      rotation = 180
      break
    case "left":
      rotation = 90
      break
    case "right":
      rotation = -90
      break
    default:
      rotation = 0
  }
  return {
    WebkitTransform: `rotate(${rotation}deg)`,
    transform: `rotate(${rotation}deg)`
  }
}

const CTA = ({
  arrowFill,
  message,
  direction,
  appearance,
  centered,
  innerRef
}: {
  arrowFill?: string,
  message: string,
  direction: Direction,
  appearance?: Appearance,
  centered?: boolean,
  innerRef?: (el: HTMLElement) => any
}) => (
  <CTAContainer appearance={appearance} innerRef={innerRef} centered={centered}>
    <SVGLoader
      path={iconDownArrow}
      fill={arrowFill || "#d9912a"}
      height="32px"
      width="32px"
      style={styleForDirection(direction)}
    />
    {message}
  </CTAContainer>
)

export default CTA



// WEBPACK FOOTER //
// ./src/Kiosk/Shared/CTA.js